import { t } from '@lingui/core/macro';
import { NoddiDateFormats, noddiFormatDate } from 'noddi-util';

export const buildCouponValidUntilLabel = (expiresAt: string | null | undefined): string | undefined => {
  if (expiresAt == null || expiresAt === '') {
    return undefined;
  }
  const formattedDate = noddiFormatDate(expiresAt, NoddiDateFormats.DATE);
  return t`Valid until ${formattedDate}`;
};
